<div class="kfi-title-bar">
    <h2 class="bo-title-text vo-heading-regular-22">{{referenceDataLabels.ApplicantsId | localizeLabel}}</h2>
    <span class="required-label vo-body-regular-14 vo-display-none">{{referenceDataLabels.MandatoryFields|localizeLabel}}</span>
</div>

<boi-kfi-applicant-control [kfiApplicants]="kfi.KfiApplicants" [isReadOnly]="kfi.IsApplicationReadOnly"
    (updateApplicantsEvent)="updateApplicantFromFullNameCache($event)">
</boi-kfi-applicant-control>
<boi-save-kfi class="buttons__bar" [saveButtonLabel]="referenceDataLabels.Save"
    [isFieldDisabled]="kfi.IsApplicationReadOnly"></boi-save-kfi>